import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { Badge, Button, Divider } from "@mui/material";
import ShortNome from '../../../utils/ShortNome';
import TextFormatado from '../../../utils/TextFormatado';
// import printerService from '../../../services/printer';
import DateHora from '../../../utils/dateHora';
import RegisterAccess from '../../../utils/registerAccess';

const dialogStyles = {
    button: {
        background: 'linear-gradient(135deg, #85287d 0%, #ad4ea3 100%)',
        color: '#fff',
        borderRadius: 10,
        boxShadow: '0 8px 16px rgba(133, 40, 125, 0.18)',
        fontWeight: 700,
        textTransform: 'none',
        padding: '7px 16px',
        '&:hover': {
            background: 'linear-gradient(135deg, #6a1d68 0%, #943d8d 100%)',
        },
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        paddingBottom: 8,
        borderBottom: '1px solid #f1e3f2',
    },
    titleText: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontWeight: 700,
        color: '#4b204d',
    },
    itemCard: {
        padding: '16px 14px',
        marginBottom: 12,
        borderRadius: 14,
        border: '1px solid #f0e3f1',
        background: '#fff',
        boxShadow: '0 6px 18px rgba(64, 25, 58, 0.03)',
    },
    userRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 12,
    },
    avatar: {
        width: 42,
        height: 42,
        border: '2px solid #f3d9f3',
        background: '#f9ebf8',
        color: '#85287d',
        fontSize: 14,
        fontWeight: 700,
    },
    subject: {
        display: 'inline-block',
        marginBottom: 8,
        padding: '4px 10px',
        borderRadius: 999,
        background: '#f6e8f7',
        color: '#6d2f6d',
        fontWeight: 700,
        fontSize: 13,
    },
    content: {
        borderRadius: 12,
        background: '#faf5fa',
        padding: '12px 14px',
        color: '#3f3f3f',
        lineHeight: 1.7,
        fontSize: 14,
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: 8,
    },
};

export default function VerTodasObservacoes(props) {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);


    // const exportToPDF = () => {
    //     printerService.printer('scroll-dialog-description')
    // }

    return (
        <div>
            <Button onClick={handleClickOpen('body')} size="small" style={dialogStyles.button}>
                ver todas
            </Button>

            <Dialog
                fullWidth
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                PaperProps={{ style: { borderRadius: 18, overflow: 'hidden' } }}
            >
                <RegisterAccess page={'ver todas observações'} />

                <DialogTitle id="scroll-dialog-title" style={dialogStyles.dialogTitle}>
                    <Box style={dialogStyles.titleText}>
                        <span>Todas observações</span>
                        <Badge
                            badgeContent={props.observacoesFeitas.length}
                            color="error"
                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        />
                    </Box>

                    {/* <IconButton onClick={() => exportToPDF()} aria-label="Imprimir observações">
                        <PrintIcon />
                    </IconButton> */}
                </DialogTitle>

                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        component="div"
                        sx={{ px: 0.5 }}
                    >
                        {props.observacoesFeitas.map((observacaoFeita) => {
                            const nomeAdmin = observacaoFeita?.admin?.dadosPessoais?.nome || 'Administrador';
                            const perfilAdmin = observacaoFeita?.admin?.dadosPessoais?.perfil || 'Gestor';
                            const fotoAdmin = observacaoFeita?.admin?.dadosPessoais?.fotoURL;
                            const assunto = observacaoFeita?.assunto || 'Sem assunto';

                            return (
                                <Box key={observacaoFeita._id} style={dialogStyles.itemCard}>
                                    <Box style={dialogStyles.userRow}>
                                        <Avatar
                                            src={fotoAdmin}
                                            alt={nomeAdmin}
                                            style={dialogStyles.avatar}
                                        >
                                            {nomeAdmin.charAt(0).toUpperCase()}
                                        </Avatar>

                                        <Box>
                                            <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#4b204d', lineHeight: 1.3 }}>
                                                <ShortNome nome={nomeAdmin} />
                                            </Typography>
                                            <Typography variant="caption" style={{ color: '#7a6a7d', display: 'block' }}>
                                                {perfilAdmin}
                                            </Typography>
                                            <Typography variant="caption" style={{ color: '#7a6a7d' }}>
                                                <DateHora date={observacaoFeita?.updatedAt ?? observacaoFeita?.data} />
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box>
                                        <Typography style={dialogStyles.subject}>
                                            {assunto}
                                        </Typography>
                                        <Box style={dialogStyles.content}>
                                            <TextFormatado texto={observacaoFeita.descricao || observacaoFeita.content || 'Sem descrição.'} />
                                        </Box>
                                    </Box>

                                    <Divider style={{ marginTop: 12 }} />
                                </Box>
                            );
                        })}
                    </DialogContentText>
                </DialogContent>

                <DialogActions style={dialogStyles.footer}>
                    <Button onClick={handleClose} variant="outlined" style={{ borderColor: '#d9bfd7', color: '#6d2f6d', borderRadius: 10 }}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
